<template>
  <div class="tenant_option_info_area" id="tenant_option_info">
    <div class="edit_area_half">
      <valueLabelSection
        :titleLabel="passwordEnableFlagLabel"
        :valueLabel="passwordEnableFlag"
      ></valueLabelSection>
      <valueLabelSection
        :titleLabel="autoLogoutEnableFlagLabel"
        :valueLabel="autoLogoutEnableFlag"
      ></valueLabelSection>
      <valueLabelSection
        :titleLabel="autoLogoutSecondLabel"
        :valueLabel="autoLogoutSecond"
      ></valueLabelSection>
      <valueLabelSection
        :titleLabel="ratingQuarityEnableFlagLabel"
        :valueLabel="ratingQuarityEnableFlag"
      ></valueLabelSection>
      <checkBoxBindSection
        :titleLabel="pushNotificationEnableFlagLabel"
        :nameValue="pushNotificationEnableFlag"
        :checked="getDisplayValue('pushNotificationEnableFlag')"
      ></checkBoxBindSection>
      <checkBoxBindSection
        :titleLabel="spEnableFlagLabel"
        :nameValue="spEnableFlag"
        :checked="getDisplayValue('spEnableFlag')"
      ></checkBoxBindSection>
      <checkBoxBindSection
        :titleLabel="contactsEnableFlagLabel"
        :nameValue="contactsEnableFlag"
        :checked="getDisplayValue('contactsEnableFlag')"
      ></checkBoxBindSection>
      <textAreaBindSection
        :titleLabel="remarksLabel"
        :bindValue="getDisplayValue('remarks')"
        @inputUpdate="inputUpdate('remarks')"
      ></textAreaBindSection>
    </div>
    <div class="edit_area_half">
      <callAppCheckboxListSection
        :titleLabel="linkedApplication"
        :callAppList="callAppList"
      ></callAppCheckboxListSection>
    </div>
  </div>
</template>

<script>
import inputSection from './inputSection.vue'
import checkBoxBindSection from './checkBoxBindSection.vue'
import textAreaBindSection from './textAreaBindSection.vue'
import dropDownSection from './dropDownSection.vue'
import valueLabelSection from './valueLabelSection.vue'
import callAppCheckboxListSection from './callAppCheckboxListSection.vue'

export default {
  data() {
    return {
      passwordEnableFlagLabel: 'アプリパスワードの使用有無',
      autoLogoutEnableFlagLabel: 'アプリ自動ログアウトの使用有無',
      autoLogoutSecondLabel: '自動ログアウト時間',
      ratingQuarityEnableFlagLabel: '評価管理機能の使用有無',
      pushNotificationEnableFlagLabel: 'push通知機能の使用有無',
      spEnableFlagLabel: 'サイレントpush通知機能の使用有無',
      contactsEnableFlagLabel: '標準電話帳連携機能の使用有無',
      remarksLabel: '備考',
      passwordLabel: '管理者パスワード',
      initialValue: 3600,
      pushNotificationEnableFlag: 'pushNotification_enable',
      spEnableFlag: 'silentPush_enable',
      contactsEnableFlag: 'contacts_enable',
      linkedApplication: '連携アプリ'
    }
  },
  components: {
    inputSection,
    checkBoxBindSection,
    textAreaBindSection,
    dropDownSection,
    valueLabelSection,
    callAppCheckboxListSection
  },
  computed: {
    corporation() {
      return this.$store.state.corporations.corporation
    },
    inputData() {
      return this.$store.state.corporations.updateCorporation
    },
    isAutoLogoutEnableFlag() {
      return this.$store.state.corporations.addCorporation.autoLogoutEnableFlag
    },
    passwordEnableFlag() {
      return this.$store.state.corporations.corporation.passwordEnableFlag
        ? 'ON'
        : 'OFF'
    },
    autoLogoutEnableFlag() {
      return this.$store.state.corporations.corporation.autoLogoutEnableFlag
        ? 'ON'
        : 'OFF'
    },
    ratingQuarityEnableFlag() {
      return this.$store.state.corporations.corporation.ratingQuarityEnableFlag
        ? 'ON'
        : 'OFF'
    },
    autoLogoutSecond() {
      return (
        parseInt(
          this.$store.state.corporations.corporation.autoLogoutSecond / 3600
        ) + '時間'
      )
    },
    callAppList() {
      const inputList = this.inputData.callAppList
      const baseList = this.corporation.callAppList || []
      const isEditing = inputList != null
      const sourceList = isEditing ? inputList : baseList
      const activeIds = new Set(
        sourceList
          .filter((app) => isEditing || app.isActiveCallAppNotNull)
          .map((app) => app.id)
      )
      const usedIds = new Set(
        baseList.filter((app) => app.isUsed).map((app) => app.id)
      )
      return this.$store.state.corporations.callAppDefine.map((app) => ({
        ...app,
        checked: activeIds.has(app.id),
        isUsed: usedIds.has(app.id)
      }))
    }
  },
  methods: {
    inputUpdate(e) {
      this.$store.dispatch('corporations/inputUpdate', {
        name: e,
        value: event.target.value
      })
    },
    getDisplayValue(path) {
      const getValueByPath = (obj, path) => {
        return path
          .split('.')
          .reduce(
            (acc, key) =>
              acc && acc[key] !== undefined ? acc[key] : undefined,
            obj
          )
      }
      const inputValue = getValueByPath(this.inputData, path)
      const baseValue = getValueByPath(this.corporation, path)
      return inputValue !== undefined && inputValue !== null
        ? inputValue
        : baseValue
    }
  }
}
</script>

<style scoped>
.corporation_bottom {
  top: 130px;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/corporationComponents/tenantOptionEditInfo.vue